export const setCookie = (name, value, expiration, path = '/') => {
    const d = new Date();
    d.setTime(d.getTime() + expiration);
    document.cookie = `${name}=${value};expires=${d.toUTCString()};path=${path}`;
};
export const getCookie = (name) => {
    const dCookie = decodeURIComponent(document.cookie);
    const cookies = dCookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cp = cookies[i].trim().split('=');
        if (cp[0] === name)
            return cp[1];
    }
    return null;
};
